import React from 'react';
import { Link } from 'react-router-dom';
import { highlightBlocks } from '../../data/homeContent';
import HomeIcon from './HomeIcon';

function HomeHighlights() {
  return (
    <section className="home-section home-highlights">
      <div className="container">
        <div className="home-section-head">
          <p className="home-kicker">WHY SCHOOLS MOVE FASTER</p>
          <h2>Intelligence, automation, and growth in one stack</h2>
        </div>
        <div className="home-highlight-grid">
          {highlightBlocks.map((block, index) => (
            <article key={block.title} className={`home-highlight-card home-highlight-card-${index + 1}`}>
              <div className="home-highlight-card-top">
                <span className="home-highlight-icon">
                  <HomeIcon name={block.icon} size={20} />
                </span>
                <b>0{index + 1}</b>
              </div>
              <p className="home-highlight-label">{block.kicker}</p>
              <h3>{block.title}</h3>
              <p className="home-highlight-text">{block.text}</p>
              <ul>
                {block.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <Link to={block.to}>{block.label}</Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeHighlights;
